import React, { useContext, useState } from "react";
import { AppContext } from "@/pages/_app";
import moment from "moment";
import Link from "next/link";
import Avatar from "react-avatar";
import { Modal, OverlayTrigger, Spinner } from "react-bootstrap";
import { FaHeart } from "react-icons/fa";
import { MdClose, MdReply } from "react-icons/md";
import Image from "next/image";
import { callBackendApi } from "@/utils/common";
import { useRouter } from "next/router";
// import Reply from "../Community/Reply";

function ReplyUserProfile(props) {
  const user = props.user;
  const reply = props.reply;
  const { loggedInUser, popoverLoginAlert } = useContext(AppContext);
  const [likeCount, setLikeCount] = useState(reply.countLikes);
  const [isLiked, setIsLiked] = useState(reply.isLiked);
  const [loadingLikeBtn, setLoadingLikeBtn] = useState(false);
  const [loadingLikesModal, setLoadingLikesModal] = useState(false);
  const [showLikesModal, setShowLikesModal] = useState(false);
  const [likesData, setLikesData] = useState(null);
  const router = useRouter();

  const handleLike = async () => {
    setLoadingLikeBtn(true);
    // get post like status
    await callBackendApi({
      method: "post",
      url: "/community/likes/reply/" + reply._id,
    })
      .then((response) => {
        if (response.data.success == true) {
          setIsLiked(true);
          setLikeCount(likeCount + 1);
        } else {
          setIsLiked(false);
        }
      })
      .catch((error) => {
        alert("error\n" + error);
      });
    setLoadingLikeBtn(false);
  };

  const handleUnLike = async () => {
    setLoadingLikeBtn(true);
    // get post like status
    await callBackendApi({
      method: "delete",
      url: "/community/likes/reply/" + reply._id,
    })
      .then((response) => {
        if (response.data.success == true) {
          setIsLiked(false);
          setLikeCount(likeCount - 1);
        } else {
          setIsLiked(true);
        }
      })
      .catch((error) => {
        alert("error\n" + error);
      });
    setLoadingLikeBtn(false);
  };

  const handleClick = () => {
    if (isLiked) {
      handleUnLike();
    } else {
      handleLike();
    }
  };

  const handleShowLikesModal = async () => {
    setLoadingLikesModal(true);
    setShowLikesModal(true);
    // get all likes data of this post
    await callBackendApi({
      method: "get",
      url: `/community/likes/reply/${reply._id}`,
    }).then((response) => {
      setLikesData(response.data.data.map((item) => item.userId));
    });
    setLoadingLikesModal(false);
  };

  const handleUserRouter = () => {
    router.push(`/u/${user.username}`);
  };

  return (
    <>
      <div className="col ps-3">
        <div className="d-flex gap-2">
          <div className="rounded-circle mds-bg-white">
            {user.imageUrl ? (
              <Image
                alt="#"
                layout="fixed"
                className="border mds-border-primary-light rounded-circle"
                src={user.imageUrl}
                width={20}
                height={20}
              />
            ) : (
              <Avatar name={user.fullName} size={20} round />
            )}
          </div>
          <div className="flex-fill   align-self-center mds-border-primary-light">
            <div className="d-flex justify-content-between ">
              <div className="d-flex align-items-center gap-2 ">
                <span
                  style={ { cursor: "pointer"}}
                  onClick={handleUserRouter}
                  className="mds-fw-md text-capitalize mds-text-dark text-nowrap"
                >
                  <a className="mds-text-primary">{user.fullName}</a>
                </span>
              </div>
            </div>
            <p
              className={
                "m-0 mb-2 mds-rounded mds-fw-sm mds-fs-4 mds-text-secondary  " +
                (reply.isDeleted && " mds-bg-primary-muted mt-2 p-2 fst-italic")
              }
            ></p>
            {typeof reply.body === "object" ? (
              reply.body.content.map((content) => {
                return (
                  <>
                    {content.hasOwnProperty("content") &&
                      content.content.map((itemContent) => {
                        return (
                          <>
                            {itemContent.type === "text" ? (
                              <>
                                {itemContent.hasOwnProperty("marks") &&
                                itemContent.marks[0].type === "link" ? (
                                  <a
                                    className="mds-text-primary"
                                    {...itemContent.marks[0].attrs}
                                  >
                                    {itemContent.text}
                                  </a>
                                ) : (
                                  <span>{itemContent.text}</span>
                                )}
                              </>
                            ) : (
                              <Link
                                href={`/company/${itemContent.attrs.id.slug}`}
                              >
                                <a className="mds-text-primary text-capitalize">
                                  @{itemContent.attrs.id.companyName}
                                </a>
                              </Link>
                            )}
                          </>
                        );
                      })}
                    <br />
                  </>
                );
              })
            ) : (
              <span className={reply.isDeleted && " text-muted "}>
                {reply.body}
              </span>
            )}
            <div className="d-flex justify-content-between align-items-center gap-3">
              <div className="d-flex align-items-center gap-2">
                <div className="d-flex align-items-center gap-2">
                  <OverlayTrigger
                    trigger={!loggedInUser && "click"}
                    placement="top"
                    rootClose
                    overlay={popoverLoginAlert}
                  >
                    <button
                      disabled={loadingLikeBtn}
                      onClick={() => loggedInUser && handleClick()}
                      className={(isLiked && " active ") + " btn pe-0 "}
                    >
                      <FaHeart
                        width={40}
                        className={
                          " mds-btn-icon mds-text-primary " +
                          (isLiked && " active ")
                        }
                      />
                    </button>
                  </OverlayTrigger>
                  <button
                    className="btn ps-0 mds-text-primary"
                    onClick={handleShowLikesModal}
                    disabled={loadingLikeBtn}
                  >
                    {loadingLikeBtn ? (
                      <Spinner animation="border" size="sm" />
                    ) : (
                      <span className="mds-fs-4 mds-fw-md">{likeCount}</span>
                    )}
                  </button>
                </div>
                <div>
                  <OverlayTrigger
                    trigger={!loggedInUser && "click"}
                    placement="top"
                    rootClose
                    overlay={popoverLoginAlert}
                  >
                    <button
                      onClick={() => {
                        loggedInUser && handleToggleSubReplyForm();
                        newSubReplyEditor.commands.focus();
                      }}
                      className="mds-fw-sm mds-fs-5 border-0 btn mds-btn mds-btn-transparent-primary d-flex gap-2 align-items-center"
                    >
                      <span style={{ width: "16px", height: "16px" }}>
                        <MdReply
                          style={{
                            width: "16px",
                            height: "16px",
                            padding: "2px",
                          }}
                          className="mds-btn-icon"
                        />
                      </span>
                      <span className="mds-fs-5">Reply</span>
                    </button>
                  </OverlayTrigger>
                </div>
              </div>
              <div className="d-flex align-items-center">
                {/* {reply.recentReplies.map((item, index) => {
                    return (
                      <>
                        {reply.userId.imageUrl ? (
                          <Image
                            key={index}
                            layout="fixed"
                            className="border mds-border-primary-light rounded-circle"
                            src={item.userId.imageUrl}
                            width={16}
                            height={16}
                          />
                        ) : (
                          <Avatar
                            key={index}
                            name={item.userId.fullName}
                            size={16}
                            round
                          />
                        )}
                      </>
                    );
                  })} */}
                <button
                  // disabled={loadingSubreplies}
                  style={{ paddingLeft: "0px", marginLeft: "0px" }}
                  // onClick={handleRepliesCountBtnClick}
                  className={
                    (!reply.countReplies > 0 && "d-none") +
                    " mds-fs-sm ms-auto btn mds-text-primary text-nowrap ps-2 d-flex align-items-center gap-1"
                  }
                >
                  {reply.countReplies + " Replies"}
                  {/* {loadingSubreplies && (
                      <Spinner
                        animation="border"1
                        size="sm"
                        className="mds-text-primary"
                      />
                    )} */}
                </button>
                <span className="text-muted mds-fs-sm ms-lg-2">
                  {moment(reply.createdAt).fromNow("dd")}
                  <span className="d-none d-lg-inline"> ago</span>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Modal
        show={showLikesModal}
        onHide={() => setShowLikesModal(false)}
        contentClassName="mds-rounded border mds-border-primary-light mds-bg-white mds-modal-shadow"
        className="mds-modal pt-5"
      >
        <Modal.Body className="mds-rounded">
          <div className="card bg-transparent border-0">
            {loadingLikesModal ? (
              <div className="d-flex justify-content-center align-items-center gap-3">
                <Spinner animation="border" className="mds-text-primary" />
                <span className="mds-fw-4 mds-fw-lg">Getting Likes ...</span>
              </div>
            ) : (
              <>
                <div className="card-body">
                  <div className="d-flex justify-content-between align-items-center">
                    <h5 className="m-0 mds-fs-4 mds-fw-md text-center">
                      {likesData?.length > 1
                        ? `${likesData?.length} people liked it`
                        : `${likesData?.length} person liked it`}
                    </h5>
                    <button
                      onClick={() => setShowLikesModal(false)}
                      className="btn p-0 px-1 mds-text-primary mds-bg-primary-muted"
                    >
                      <MdClose />
                    </button>
                  </div>
                </div>
                <div className="list-group list-group-flush mds-list-group-flush">
                  {likesData?.map((item) => (
                    <div key={item._id} className="list-group-item">
                      <div className="d-flex justify-content-start align-items-center gap-3">
                        {item.imageUrl ? (
                          <Image
                            layout="fixed"
                            className="border mds-border-primary-light rounded-circle"
                            src={item.imageUrl}
                            width={40}
                            height={40}
                          />
                        ) : (
                          <Avatar name={item.fullName} size={40} round />
                        )}
                        <span className="mds-fs-4 text-capitalize text-nowrap">
                          {item.fullName}
                        </span>
                      </div>
                    </div>
                  ))}
                </div>
              </>
            )}
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default ReplyUserProfile;
